import type { BetSlipBetsState } from '@mobi/betslip/Store/Bets'
import type { RequestType } from '@mobi/betslip/types'
import { buildBetSlipRequest } from '@mobi/betslip/helpers/requestBuilder'
import {
  betslipPropose as propose,
  betslipCommit as commit,
  betslipRefresh as refresh,
} from '@core/Data/betting'

export async function postAllBetsToServer(
  queryType: RequestType,
  state: Pick<BetSlipBetsState, 'items' | 'multiBetError' | 'multiInvestment' | 'multiReceipt'>,
  options: PostAllBetsToServerOptions = {}
) {
  const request = buildBetSlipRequest({ queryType, state, options })

  if (queryType === 'propose') {
    const response = await propose(request)
    return response
  }

  if (queryType === 'confirm') {
    const response = await commit(request)
    return response
  }

  const response = await refresh(request)
  return response
}

// =====
// Types
// =====

type PostAllBetsToServerOptions = Parameters<typeof buildBetSlipRequest>['0']['options']
